import { handleHideModal, handleInputChange } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import UniversalInput from 'components/global/UniversalInput';
import { handleSubmitEditTeam } from 'components/views/InvestorTeam/_helpers/investorTeam.events';
import { Col, Row } from 'react-bootstrap';
import { $form, $view } from 'signals/global.signals';

const InvestorEditTeamModal = () => (
  <SimpleModal
    show={$view.value.activeModal === 'edit-team'}
    onHide={handleHideModal}
    enforceFocus={false}
    title="Edit Team"
    primaryButtonText="Save"
    onPrimaryClick={handleSubmitEditTeam}
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    isLoading={$view.value.isModalLoading}
  >
    <Row>
      <Col>
        <UniversalInput
          name="name"
          label="Team Name"
          value={$form.value.name}
          className="mb-16"
        />
        <UniversalInput
          type="select"
          name="users"
          label="Users"
          isMulti
          options={$view.value.userOptions}
          onChange={(selectedOptions) => {
            handleInputChange({ name: 'users', value: selectedOptions });
          }}
        />
      </Col>
    </Row>
  </SimpleModal>
);

export default InvestorEditTeamModal;
